export const GET_COST_CENTERS = 'GET_COST_CENTERS';
export const SET_COST_CENTERS_PAGINATION = 'SET_COST_CENTERS_PAGINATION';
export const SET_COST_CENTERS_FILTERS = 'SET_COST_CENTERS_FILTERS';
export const RESET_COST_CENTERS = 'RESET_COST_CENTERS';
export const TOGGLE_COST_CENTER = 'TOGGLE_COST_CENTER';
export const ADD_COST_CENTER = 'ADD_COST_CENTER';
export const UPDATE_COST_CENTER = 'UPDATE_COST_CENTER';
export const GET_COST_CENTER_BY_ID = 'GET_COST_CENTER_BY_ID';
export const RESET_COST_CENTER_FORM = 'RESET_COST_CENTER_FORM';
export const MODIFY_EDITING_COST_CENTER = 'MODIFY_EDITING_COST_CENTER';

//Groups
export const MODIFY_CUSTOM_FIELD_EDITING_COST_CENTER = 'MODIFY_CUSTOM_FIELD_EDITING_COST_CENTER';



// WEBPACK FOOTER //
// src/modules/secured/modules/cost_centers/constants/cost_centers_constants.js